// extracted by mini-css-extract-plugin
module.exports = {"image":"styles__image__1AiOX"};